"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

export const memoryToolRegistry = {
  memory: {
    kind: "step",
    category: "memory",
    view: lazy(() =>
      import("./memory").then(({ MemoryToolView }) => ({
        default: MemoryToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;
